import { Action } from '@ngrx/store'
import { CashBalancesViewType, CashBalancesModel, CashBalanceConfiguration, SubLedgerModel} from '@cash-balances/old_index';
import { IContext } from '../../context/models/context';
import { RuleSet } from 'ngx-angular-query-builder';


export const LOAD = '[Cash Balances] Load';
export const LOAD_COMPLETE = '[Cash Balances] Load Complete';
export const LOAD_ERROR = '[Cash Balances] Load Error';
export const UPDATE_GROUPING = '[Cash Balances] Update Grouping';
export const UPDATE_VIEW = '[Cash Balances] Update View';

export const LOAD_CONFIGURATION = '[Cash Balances] Load Configuration';
export const LOAD_CONFIGURATION_COMPLETE = '[Cash Balances] Load Configuration Complete';
export const LOAD_CONFIGURATION_ERROR = '[Cash Balances] Load Configuration Error';

export const LOAD_SUB_LEDGERS = '[Cash Balances Sub Ledgers] Load';
export const LOAD_SUB_LEDGERS_COMPLETE = '[Cash Balances Sub Ledgers] Load Complete';
export const LOAD_SUB_LEDGERS_ERROR = '[Cash Balances Sub Ledgers] Load Error';

export class Load implements Action {
  readonly type = LOAD;
  constructor(public context: IContext, public widgetId: string ) { }
}
export class LoadComplete implements Action {
  readonly type = LOAD_COMPLETE;
  constructor(public payload: Array<CashBalancesModel>, public widgetId: string ) { }
}

export class LoadError implements Action {
  readonly type = LOAD_ERROR;

  constructor(public payload: any, public widgetId: string ) { }
}

export class LoadConfiguration implements Action {
  readonly type = LOAD_CONFIGURATION;
  constructor(public widgetConfigurationId: number, public widgetId: string) { }
}
export class LoadConfigurationComplete implements Action {
  readonly type = LOAD_CONFIGURATION_COMPLETE;
  constructor(public payload: CashBalanceConfiguration, public widgetId: string) { }
}

export class LoadConfigurationError implements Action {
  readonly type = LOAD_CONFIGURATION_ERROR;

  constructor(public payload: any, public widgetId: string) { }
}

export class UpdateGrouping implements Action {
  readonly type = UPDATE_GROUPING;
  constructor(public widgetId: string, public groupByField1: string, public groupByField2: string, public currency: string) { }
}

export class UpdateView implements Action {
  readonly type = UPDATE_VIEW;
  constructor(public widgetId: string, public view: CashBalancesViewType) { }
}

export class LoadSubLedgers implements Action {
  readonly type = LOAD_SUB_LEDGERS;
  constructor() { }
}
export class LoadSubLedgersComplete implements Action {
  readonly type = LOAD_SUB_LEDGERS_COMPLETE;
  constructor(public payload: Array<SubLedgerModel>) { }
}

export class LoadSubLedgersError implements Action {
  readonly type = LOAD_SUB_LEDGERS_ERROR;

  constructor(public payload: any) { }
}


export type Actions =
  Load |
  LoadComplete |
  LoadError |
  UpdateGrouping |
  UpdateView |
  LoadSubLedgers |
  LoadSubLedgersComplete |
  LoadSubLedgersError |
  LoadConfiguration |
  LoadConfigurationComplete |
  LoadConfigurationError;
